export default __webpack_public_path__ + "static/media/teng2.82b99303.png";